import React, {useEffect, useState} from 'react';
import {Form} from "react-bootstrap";
import SearchSelect from "../../../components/searchSelect";
import axios from "../../../helpers/axios";
import {Portlet, PortletBody} from "../../../components/Portlet";
import BlockUi from "@availity/block-ui";

const ListForm = ({query, setQuery}) => {
  const [options, setOptions]=useState({
    buyer:null,
  })

  useEffect(() => {
    axios.post('/api/counterparty/searchInput', )
      .then(({data})=>{
        setOptions(o=>({...o, buyer: data.data}))
      })
  }, []);
  return (
    <Portlet style={{minHeight : "88.39px"}}>
      <PortletBody>
        <BlockUi blocking={!options.buyer}>
          {options.buyer && <div className={'d-flex justify-content-between gap-2 '}>
            <div className={'d-flex gap-2 flex-wrap'}>
              <div style={{position: 'relative', width: '8rem'}}>
                <label className={'absolutLabel'}>Бронирование</label>
                <Form.Control
                  defaultValue={query.orderNumber}
                  value={query.orderNumber || ''}
                  onChange={(e) => setQuery(q => ({...q, orderNumber: e.target.value}))}
                  className={'form-control'}
                  type={'text'}
                />
              </div>
              <div style={{position: 'relative', width: '13rem'}}>
                <label className={'absolutLabel'}>Билет</label>
                <Form.Control
                  defaultValue={query.ticketNumber}
                  value={query.ticketNumber || ''}
                  onChange={(e) => setQuery(q => ({...q, ticketNumber: e.target.value}))}
                  className={'form-control'}
                  type={'text'}
                />
              </div>
              <div style={{position: 'relative', width: '13rem'}}>
                <label className={'absolutLabel'}>Турист</label>
                <Form.Control
                  name={'search'}
                  defaultValue={query.pax}
                  value={query.pax || ''}
                  onChange={(e) => setQuery(q => ({...q, pax: e.target.value}))}
                  className={'form-control'}
                  type={'text'}
                  placeholder="Фамилия,Имя"
                />
              </div>
              <div style={{width: '14rem'}}>
                <SearchSelect
                  onChange={v => {
                    console.log('v', v)
                    setQuery(q => ({...q, buyer: v}))
                  }}
                  defaultValue={query.buyer}
                  label={'Покупатель'}
                  unregister
                  array={[{value: '', label: 'Все'}, ...options.buyer]}/>
              </div>
              <div style={{position: 'relative', width: '13rem'}}>
                <label className={'absolutLabel'}>Откуда</label>
                <Form.Control
                  defaultValue={query.departure}
                  value={query.departure || ''}
                  onChange={(e) => setQuery(q => ({...q, departure: e.target.value}))}
                  className={'form-control'}
                  type={'text'}
                  placeholder=""
                />
              </div>
              <div style={{position: 'relative', width: '13rem'}}>
                <label className={'absolutLabel'}>Куда</label>
                <Form.Control
                  defaultValue={query.arrival}
                  value={query.arrival || ''}
                  onChange={(e) => setQuery(q => ({...q, arrival: e.target.value}))}
                  className={'form-control'}
                  type={'text'}
                  placeholder=""
                />
              </div>
            </div>
            <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
              Для оплат
              <input
                defaultChecked={query.forPaiments}
                checked={query.forPaiments}
                onChange={(e) => {
                  setQuery(q => ({...q, forPaiments: e.target.checked}))
                }}
                type={"checkbox"}
              />{" "}
            </Form.Label>

          </div>
          }
        </BlockUi>
      </PortletBody>
    </Portlet>
  );
};

export default ListForm;
